import React, { forwardRef } from 'react';

interface FormCheckboxProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label: string;
  error?: string;
  helperText?: string;
  checked: boolean;
}

const FormCheckbox = forwardRef<HTMLInputElement, FormCheckboxProps>(
  ({ label, error, helperText, checked, className, ...rest }, ref) => {
    return (
      <div className={`${className || ''} mb-2`}>
        <label className="flex items-center cursor-pointer">
          <div className="flex-shrink-0">
            <input
              type="checkbox"
              ref={ref}
              checked={checked}
              className="h-4 w-4 rounded border-gray-300 text-blue-600 focus:ring-blue-500"
              {...rest}
            />
          </div>
          <span className="ml-2 text-sm text-gray-700">{label}</span>
        </label>

        {helperText && !error && (
          <p className="mt-1 text-sm text-gray-500 ml-6">{helperText}</p>
        )}

        {error && (
          <p className="mt-1 text-sm text-red-600 ml-6">{error}</p>
        )}
      </div>
    );
  }
);

FormCheckbox.displayName = 'FormCheckbox';

export default FormCheckbox;